import { createBrowserHistory } from 'history'

const urlBase = __CHS_INT_WEB_URL_BASE__
const history = createBrowserHistory({ basename: urlBase })

export default history
